<div class="container">
  <!-- Sección de lista/información de Visionboard -->
  <div class="visionboard-section">
    <!-- Header con Breadcrumb -->
    <div class="vb-header">
      <div class="vb-breadcrumb">
        <span class="breadcrumb-normal">Descubrete</span>
        <span class="breadcrumb-separator"> > </span>
        <span class="breadcrumb-active">Visión Board</span>
      </div>
    </div>

    <!-- Modal Actions -->
    <div class="vb-modal-actions" *ngIf="userVisionboards.length > 0">
      <!-- <button class="btn-exit" (click)="navigateToEditor(userVisionboards[0].id)">
                Salir
            </button> -->
      <button
        class="btn-save"
        (click)="onVisionboardSaved()"
        *ngIf="showFinishButton"
        [disabled]="isFinishingVisionboard"
      >
        <span *ngIf="!isFinishingVisionboard">Guardar Vision Board</span>
        <span *ngIf="isFinishingVisionboard" class="btn-loading-content">
          <span class="spinner"></span>
          Guardando...
        </span>
      </button>
    </div>

    <!-- Status Indicator - Banner verde (solo si existe visionboard) -->
    <div class="vb-status-banner" *ngIf="userVisionboards.length > 0">
      <svg
        class="status-icon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <circle cx="8" cy="8" r="7" fill="#4CAF50" />
        <path
          d="M11.3337 5.33334L6.66699 10L4.66699 8"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <span class="status-text">{{ countdownMessage }}</span>
    </div>

    <!-- Sección informativa "Antes de crear tu Vision Board" -->
    <div class="vb-info-section">
      <div class="vb-info-header">
        <h2 class="vb-info-title">Antes de crear tu Vision Board</h2>
        <div class="vb-tip-icon">
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none">
            <circle cx="12" cy="12.5" r="11" fill="#FFF5F2" />
            <circle cx="12" cy="12.5" r="3" fill="#EA5A42" />
            <ellipse cx="17.5" cy="7.5" rx="2" ry="2.5" fill="#EA5A42" />
          </svg>
        </div>
      </div>
      <div class="vb-info-content">
        <p class="vb-info-text">
          Tómate un momento para imaginar tu futuro ideal: ¿cómo quieres que sea
          tu vida, con quién te ves, qué estás logrando? Reflexiona sobre lo que
          realmente valoras, lo que quieres cambiar y las metas que te motivan.
          Usa imágenes o frases que representen áreas clave como salud, familia,
          desarrollo personal, carrera y diversión. Recuerda: mientras más
          claras y alineadas estén tus visualizaciones con tu propósito, mayores
          serán tus posibilidades de éxito. No estás solo en este camino,
          cuentas con la comunidad Phoenix para inspirarte y acompañarte.
        </p>
        <button class="vb-download-pdf-btn" (click)="downloadPDF()">
          <span class="vb-download-text">Descargar PDF</span>
          <svg
            class="vb-download-icon"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14 2V8H20"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16 13H8"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16 17H8"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10 9H8"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- Si no hay Visionboards -->
    <!-- <div *ngIf="userVisionboards.length === 0 && !isLoadingVisionboards" class="vb-empty-state">
            <div class="vb-empty-actions">
                <button class="btn-primary" (click)="navigateToEditor()">Crear Visionboard</button>
        </div>

            <div class="empty-message">
                <p>Aún no has creado ningún Visionboard. ¡Comienza ahora!</p>
        </div>
    </div> -->

    <!-- Loader -->
    <!-- <div *ngIf="isLoadingVisionboards" class="loading-message">Cargando tus visionboards...</div> -->

    <!-- Visionboard Display -->
    <div class="visionboard-display">
      <!-- Mensaje para vista móvil -->
      <div class="vb-mobile-message">
        <div class="vb-mobile-content">
          <div class="vb-mobile-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 2L2 7L12 12L22 7L12 2Z"
                stroke="#EA5A42"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2 17L12 22L22 17"
                stroke="#EA5A42"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2 12L12 17L22 12"
                stroke="#EA5A42"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <h3 class="vb-mobile-title">Vision Board</h3>
          <p class="vb-mobile-description">
            Para una mejor experiencia, crea y edita tu Vision Board desde un
            dispositivo de escritorio. Aquí podrás ver una vista previa de tu
            tablero.
          </p>
          <button
            class="vb-mobile-button"
            *ngIf="userVisionboards.length > 0 && userVisionboards[0]?.id"
            (click)="navigateToEditor(userVisionboards[0].id)"
          >
            Ver en Escritorio
          </button>
        </div>
      </div>

      <!-- Contenido para vista desktop -->
      <div class="vb-desktop-content">
        <div class="vb-board-container">
          <div class="vb-board-header">
            <input
              type="text"
              class="vb-board-title-input"
              [(ngModel)]="visionboardTitle"
              (blur)="saveTitle()"
              (keyup.enter)="saveTitle()"
              placeholder="Ingrese Titulo"
              maxlength="50"
            />
          </div>

          <!-- Barra de herramientas de la pizarra -->
          <div class="vb-whiteboard-toolbar">
            <div class="vb-tool-group">
              <button
                class="vb-tool-btn"
                [class.active]="currentTool === 'pen'"
                [disabled]="!whiteboardEnabled"
                (click)="setTool('pen')"
                title="Lápiz"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 19L19 12L22 15L15 22L12 19Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M18 13L16.5 5.5L2 2L5.5 16.5L13 18L18 13Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2 2L7.586 7.586"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11 13C11.5523 13 12 12.5523 12 12C12 11.4477 11.5523 11 11 11C10.4477 11 10 11.4477 10 12C10 12.5523 10.4477 13 11 13Z"
                    fill="currentColor"
                  />
                </svg>
              </button>
              <button
                class="vb-tool-btn"
                [class.active]="currentTool === 'highlighter'"
                [disabled]="!whiteboardEnabled"
                (click)="setTool('highlighter')"
                title="Resaltador"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M9 11L12 14L22 4"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M21 12L21 19C21 19.5523 20.5523 20 20 20L4 20C3.44772 20 3 19.5523 3 19L3 12"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M3 8L3 5C3 4.44772 3.44772 4 4 4L20 4C20.5523 4 21 4.44772 21 5L21 8"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <button
                class="vb-tool-btn"
                [class.active]="currentTool === 'text'"
                [disabled]="!whiteboardEnabled"
                (click)="setTool('text')"
                title="Texto libre"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M4 7V4C4 3.44772 4.44772 3 5 3H19C19.5523 3 20 3.44772 20 4V7"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 9H15"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 13H15"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 17H13"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4 21L4 7"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <button
                class="vb-tool-btn"
                [class.active]="currentTool === 'eraser'"
                [disabled]="!whiteboardEnabled"
                (click)="setTool('eraser')"
                title="Borrador"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M7 21H4C3.44772 21 3 20.5523 3 20V17"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M21 3L8 16L12 20L25 7L21 3Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17 7L21 3"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>

            <div class="vb-tool-group">
              <input
                type="color"
                class="vb-color-picker"
                [(ngModel)]="currentColor"
                [disabled]="!whiteboardEnabled"
                (change)="updateColor($event)"
                title="Color"
              />
              <input
                type="range"
                class="vb-brush-size"
                min="1"
                max="20"
                [(ngModel)]="brushSize"
                [disabled]="!whiteboardEnabled"
                (input)="updateBrushSize($event)"
                title="Tamaño del pincel"
              />
              <span class="vb-brush-size-label">{{ brushSize }}px</span>
            </div>

            <div class="vb-tool-group">
              <button
                class="vb-tool-btn"
                [disabled]="!whiteboardEnabled"
                (click)="clearWhiteboard()"
                title="Limpiar pizarra"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M3 6H5H21"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8 6V4C8 3.44772 8.44772 3 9 3H15C15.5523 3 16 3.44772 16 4V6M19 6V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V6H19Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10 11V17"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14 11V17"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <button
                class="vb-tool-btn"
                [disabled]="!whiteboardEnabled"
                (click)="saveWhiteboardManually()"
                title="Guardar pizarra"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M19 21H5C4.44772 21 4 20.5523 4 20V4C4 3.44772 4.44772 3 5 3H16L20 7V20C20 20.5523 19.5523 21 19 21Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17 21V13H7V21"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7 3V7H15"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <button
                class="vb-tool-btn"
                (click)="toggleWhiteboard()"
                [class.active]="whiteboardEnabled"
                *ngIf="showFinishButton"
                title="Activar/Desactivar pizarra"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 2L2 7L12 12L22 7L12 2Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2 17L12 22L22 17"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2 12L12 17L22 12"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>

          <!-- Contenido para PDF (sin toolbar) -->
          <div class="vb-pdf-content" #pdfContent>
            <!-- Vision Board Grid según Figma -->
            <div class="vb-masonry-grid" #masonryGrid>
              <!-- Canvas para pizarra interactiva -->
              <canvas
                #whiteboardCanvas
                class="vb-whiteboard-canvas"
                (mousedown)="startDrawing($event)"
                (mousemove)="draw($event)"
                (mouseup)="stopDrawing()"
                (mouseleave)="stopDrawing()"
                (touchstart)="startDrawing($event)"
                (touchmove)="draw($event)"
                (touchend)="stopDrawing()"
              >
              </canvas>
              <!-- Columna 1 -->
              <div class="vb-column vb-column-1">
                <div
                  class="vb-grid-item vb-item-tall"
                  [ngClass]="{'vb-has-content': userVisionboards[0]?.images?.[0]?.imageId || userVisionboards[0]?.images?.[0]?.text}"
                  (click)="openItemOptions($event, 0)"
                >
                  <input
                    #fileInput0
                    type="file"
                    accept="image/*"
                    (change)="onImageSelected($event, 0)"
                    style="display: none"
                  />

                  <!-- Si tiene imagen -->
                  <img
                    *ngIf="userVisionboards[0]?.images?.[0]?.imageId && getPreviewForListItem(userVisionboards[0]?.images?.[0]?.imageId)"
                    [src]="getPreviewForListItem(userVisionboards[0]?.images?.[0]?.imageId)"
                    alt="Imagen"
                    class="vb-image"
                  />

                  <!-- Si tiene texto -->
                  <div
                    *ngIf="userVisionboards[0]?.images?.[0]?.text && !userVisionboards[0]?.images?.[0]?.imageId"
                    class="vb-text-content"
                  >
                    <p class="vb-text">
                      {{ userVisionboards[0]?.images?.[0]?.text }}
                    </p>
                  </div>

                  <!-- Si está vacío -->
                  <div
                    *ngIf="!userVisionboards[0]?.images?.[0]?.imageId && !userVisionboards[0]?.images?.[0]?.text"
                    class="vb-placeholder-content"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      class="upload-icon"
                    >
                      <path
                        d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M17 8L12 3L7 8"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12 3V15"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span class="vb-placeholder-text"
                      >Sube tu imagen o escribe aquí</span
                    >
                  </div>
                </div>
                <div
                  class="vb-grid-item vb-item-medium"
                  [ngClass]="{'vb-has-content': userVisionboards[0]?.images?.[1]?.imageId || userVisionboards[0]?.images?.[1]?.text}"
                  (click)="openItemOptions($event, 1)"
                >
                  <input
                    #fileInput1
                    type="file"
                    accept="image/*"
                    (change)="onImageSelected($event, 1)"
                    style="display: none"
                  />

                  <img
                    *ngIf="userVisionboards[0]?.images?.[1]?.imageId && getPreviewForListItem(userVisionboards[0]?.images?.[1]?.imageId)"
                    [src]="getPreviewForListItem(userVisionboards[0]?.images?.[1]?.imageId)"
                    alt="Imagen"
                    class="vb-image"
                  />

                  <div
                    *ngIf="userVisionboards[0]?.images?.[1]?.text && !userVisionboards[0]?.images?.[1]?.imageId"
                    class="vb-text-content"
                  >
                    <p class="vb-text">
                      {{ userVisionboards[0]?.images?.[1]?.text }}
                    </p>
                  </div>

                  <div
                    *ngIf="!userVisionboards[0]?.images?.[1]?.imageId && !userVisionboards[0]?.images?.[1]?.text"
                    class="vb-placeholder-content"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      class="upload-icon"
                    >
                      <path
                        d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M17 8L12 3L7 8"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12 3V15"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span class="vb-placeholder-text"
                      >Sube tu imagen o escribe aquí</span
                    >
                  </div>
                </div>
                <div
                  class="vb-grid-item vb-item-large"
                  [ngClass]="{'vb-has-content': userVisionboards[0]?.images?.[2]?.imageId || userVisionboards[0]?.images?.[2]?.text}"
                  (click)="openItemOptions($event, 2)"
                >
                  <input
                    #fileInput2
                    type="file"
                    accept="image/*"
                    (change)="onImageSelected($event, 2)"
                    style="display: none"
                  />

                  <img
                    *ngIf="userVisionboards[0]?.images?.[2]?.imageId && getPreviewForListItem(userVisionboards[0]?.images?.[2]?.imageId)"
                    [src]="getPreviewForListItem(userVisionboards[0]?.images?.[2]?.imageId)"
                    alt="Imagen"
                    class="vb-image"
                  />

                  <div
                    *ngIf="userVisionboards[0]?.images?.[2]?.text && !userVisionboards[0]?.images?.[2]?.imageId"
                    class="vb-text-content"
                  >
                    <p class="vb-text">
                      {{ userVisionboards[0]?.images?.[2]?.text }}
                    </p>
                  </div>

                  <div
                    *ngIf="!userVisionboards[0]?.images?.[2]?.imageId && !userVisionboards[0]?.images?.[2]?.text"
                    class="vb-placeholder-content"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      class="upload-icon"
                    >
                      <path
                        d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M17 8L12 3L7 8"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12 3V15"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span class="vb-placeholder-text"
                      >Sube tu imagen o escribe aquí</span
                    >
                  </div>
                </div>
              </div>

              <!-- Columna 2 -->
              <div class="vb-column vb-column-2">
                <div
                  class="vb-grid-item vb-item-medium"
                  [ngClass]="{'vb-has-content': userVisionboards[0]?.images?.[3]?.imageId || userVisionboards[0]?.images?.[3]?.text}"
                  (click)="openItemOptions($event, 3)"
                >
                  <input
                    #fileInput3
                    type="file"
                    accept="image/*"
                    (change)="onImageSelected($event, 3)"
                    style="display: none"
                  />

                  <img
                    *ngIf="userVisionboards[0]?.images?.[3]?.imageId && getPreviewForListItem(userVisionboards[0]?.images?.[3]?.imageId)"
                    [src]="getPreviewForListItem(userVisionboards[0]?.images?.[3]?.imageId)"
                    alt="Imagen"
                    class="vb-image"
                  />

                  <div
                    *ngIf="userVisionboards[0]?.images?.[3]?.text && !userVisionboards[0]?.images?.[3]?.imageId"
                    class="vb-text-content"
                  >
                    <p class="vb-text">
                      {{ userVisionboards[0]?.images?.[3]?.text }}
                    </p>
                  </div>

                  <div
                    *ngIf="!userVisionboards[0]?.images?.[3]?.imageId && !userVisionboards[0]?.images?.[3]?.text"
                    class="vb-placeholder-content"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      class="upload-icon"
                    >
                      <path
                        d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M17 8L12 3L7 8"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12 3V15"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span class="vb-placeholder-text"
                      >Sube tu imagen o escribe aquí</span
                    >
                  </div>
                </div>
                <div
                  class="vb-grid-item vb-item-tall"
                  [ngClass]="{'vb-has-content': userVisionboards[0]?.images?.[4]?.imageId || userVisionboards[0]?.images?.[4]?.text}"
                  (click)="openItemOptions($event, 4)"
                >
                  <input
                    #fileInput4
                    type="file"
                    accept="image/*"
                    (change)="onImageSelected($event, 4)"
                    style="display: none"
                  />

                  <img
                    *ngIf="userVisionboards[0]?.images?.[4]?.imageId && getPreviewForListItem(userVisionboards[0]?.images?.[4]?.imageId)"
                    [src]="getPreviewForListItem(userVisionboards[0]?.images?.[4]?.imageId)"
                    alt="Imagen"
                    class="vb-image"
                  />

                  <div
                    *ngIf="userVisionboards[0]?.images?.[4]?.text && !userVisionboards[0]?.images?.[4]?.imageId"
                    class="vb-text-content"
                  >
                    <p class="vb-text">
                      {{ userVisionboards[0]?.images?.[4]?.text }}
                    </p>
                  </div>

                  <div
                    *ngIf="!userVisionboards[0]?.images?.[4]?.imageId && !userVisionboards[0]?.images?.[4]?.text"
                    class="vb-placeholder-content"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      class="upload-icon"
                    >
                      <path
                        d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M17 8L12 3L7 8"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12 3V15"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span class="vb-placeholder-text"
                      >Sube tu imagen o escribe aquí</span
                    >
                  </div>
                </div>
              </div>

              <!-- Columna 3 -->
              <div class="vb-column vb-column-3">
                <div
                  class="vb-grid-item vb-item-short"
                  [ngClass]="{'vb-has-content': userVisionboards[0]?.images?.[5]?.imageId || userVisionboards[0]?.images?.[5]?.text}"
                  (click)="openItemOptions($event, 5)"
                >
                  <input
                    #fileInput5
                    type="file"
                    accept="image/*"
                    (change)="onImageSelected($event, 5)"
                    style="display: none"
                  />

                  <img
                    *ngIf="userVisionboards[0]?.images?.[5]?.imageId && getPreviewForListItem(userVisionboards[0]?.images?.[5]?.imageId)"
                    [src]="getPreviewForListItem(userVisionboards[0]?.images?.[5]?.imageId)"
                    alt="Imagen"
                    class="vb-image"
                  />

                  <div
                    *ngIf="userVisionboards[0]?.images?.[5]?.text && !userVisionboards[0]?.images?.[5]?.imageId"
                    class="vb-text-content"
                  >
                    <p class="vb-text">
                      {{ userVisionboards[0]?.images?.[5]?.text }}
                    </p>
                  </div>

                  <div
                    *ngIf="!userVisionboards[0]?.images?.[5]?.imageId && !userVisionboards[0]?.images?.[5]?.text"
                    class="vb-placeholder-content"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      class="upload-icon"
                    >
                      <path
                        d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M17 8L12 3L7 8"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12 3V15"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span class="vb-placeholder-text"
                      >Sube tu imagen o escribe aquí</span
                    >
                  </div>
                </div>
                <div
                  class="vb-grid-item vb-item-medium-tall"
                  [ngClass]="{'vb-has-content': userVisionboards[0]?.images?.[6]?.imageId || userVisionboards[0]?.images?.[6]?.text}"
                  (click)="openItemOptions($event, 6)"
                >
                  <input
                    #fileInput6
                    type="file"
                    accept="image/*"
                    (change)="onImageSelected($event, 6)"
                    style="display: none"
                  />

                  <img
                    *ngIf="userVisionboards[0]?.images?.[6]?.imageId && getPreviewForListItem(userVisionboards[0]?.images?.[6]?.imageId)"
                    [src]="getPreviewForListItem(userVisionboards[0]?.images?.[6]?.imageId)"
                    alt="Imagen"
                    class="vb-image"
                  />

                  <div
                    *ngIf="userVisionboards[0]?.images?.[6]?.text && !userVisionboards[0]?.images?.[6]?.imageId"
                    class="vb-text-content"
                  >
                    <p class="vb-text">
                      {{ userVisionboards[0]?.images?.[6]?.text }}
                    </p>
                  </div>

                  <div
                    *ngIf="!userVisionboards[0]?.images?.[6]?.imageId && !userVisionboards[0]?.images?.[6]?.text"
                    class="vb-placeholder-content"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      class="upload-icon"
                    >
                      <path
                        d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M17 8L12 3L7 8"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12 3V15"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span class="vb-placeholder-text"
                      >Sueño con ser bailarina profesional y poder enseñarle a
                      otras chicas a bailar</span
                    >
                  </div>
                </div>

                <div
                  class="vb-grid-item vb-item-medium"
                  [ngClass]="{'vb-has-content': userVisionboards[0]?.images?.[7]?.imageId || userVisionboards[0]?.images?.[7]?.text}"
                  (click)="openItemOptions($event, 7)"
                >
                  <input
                    #fileInput7
                    type="file"
                    accept="image/*"
                    (change)="onImageSelected($event, 7)"
                    style="display: none"
                  />

                  <img
                    *ngIf="userVisionboards[0]?.images?.[7]?.imageId && getPreviewForListItem(userVisionboards[0]?.images?.[7]?.imageId)"
                    [src]="getPreviewForListItem(userVisionboards[0]?.images?.[7]?.imageId)"
                    alt="Imagen"
                    class="vb-image"
                  />

                  <div
                    *ngIf="userVisionboards[0]?.images?.[7]?.text && !userVisionboards[0]?.images?.[7]?.imageId"
                    class="vb-text-content"
                  >
                    <p class="vb-text">
                      {{ userVisionboards[0]?.images?.[7]?.text }}
                    </p>
                  </div>

                  <div
                    *ngIf="!userVisionboards[0]?.images?.[7]?.imageId && !userVisionboards[0]?.images?.[7]?.text"
                    class="vb-placeholder-content"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      class="upload-icon"
                    >
                      <path
                        d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M17 8L12 3L7 8"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12 3V15"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span class="vb-placeholder-text"
                      >Sube tu imagen o escribe aquí</span
                    >
                  </div>
                </div>
              </div>

              <!-- Columna 4 -->
              <div class="vb-column vb-column-4">
                <div
                  class="vb-grid-item vb-item-medium"
                  [ngClass]="{'vb-has-content': userVisionboards[0]?.images?.[8]?.imageId || userVisionboards[0]?.images?.[8]?.text}"
                  (click)="openItemOptions($event, 8)"
                >
                  <input
                    #fileInput8
                    type="file"
                    accept="image/*"
                    (change)="onImageSelected($event, 8)"
                    style="display: none"
                  />

                  <img
                    *ngIf="userVisionboards[0]?.images?.[8]?.imageId && getPreviewForListItem(userVisionboards[0]?.images?.[8]?.imageId)"
                    [src]="getPreviewForListItem(userVisionboards[0]?.images?.[8]?.imageId)"
                    alt="Imagen"
                    class="vb-image"
                  />

                  <div
                    *ngIf="userVisionboards[0]?.images?.[8]?.text && !userVisionboards[0]?.images?.[8]?.imageId"
                    class="vb-text-content"
                  >
                    <p class="vb-text">
                      {{ userVisionboards[0]?.images?.[8]?.text }}
                    </p>
                  </div>

                  <div
                    *ngIf="!userVisionboards[0]?.images?.[8]?.imageId && !userVisionboards[0]?.images?.[8]?.text"
                    class="vb-placeholder-content"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      class="upload-icon"
                    >
                      <path
                        d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M17 8L12 3L7 8"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12 3V15"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span class="vb-placeholder-text"
                      >Sube tu imagen o escribe aquí</span
                    >
                  </div>
                </div>
                <div
                  class="vb-grid-item vb-item-extra-tall"
                  [ngClass]="{'vb-has-content': userVisionboards[0]?.images?.[9]?.imageId || userVisionboards[0]?.images?.[9]?.text}"
                  (click)="openItemOptions($event, 9)"
                >
                  <input
                    #fileInput9
                    type="file"
                    accept="image/*"
                    (change)="onImageSelected($event, 9)"
                    style="display: none"
                  />

                  <img
                    *ngIf="userVisionboards[0]?.images?.[9]?.imageId && getPreviewForListItem(userVisionboards[0]?.images?.[9]?.imageId)"
                    [src]="getPreviewForListItem(userVisionboards[0]?.images?.[9]?.imageId)"
                    alt="Imagen"
                    class="vb-image"
                  />

                  <div
                    *ngIf="userVisionboards[0]?.images?.[9]?.text && !userVisionboards[0]?.images?.[9]?.imageId"
                    class="vb-text-content"
                  >
                    <p class="vb-text">
                      {{ userVisionboards[0]?.images?.[9]?.text }}
                    </p>
                  </div>

                  <div
                    *ngIf="!userVisionboards[0]?.images?.[9]?.imageId && !userVisionboards[0]?.images?.[9]?.text"
                    class="vb-placeholder-content"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      class="upload-icon"
                    >
                      <path
                        d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M17 8L12 3L7 8"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12 3V15"
                        stroke="#AAAAAA"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span class="vb-placeholder-text"
                      >Sube tu imagen o escribe aquí</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Cierre del vb-pdf-content -->
      </div>
    </div>
  </div>

  <!-- Botón para editar Vision Board -->
  <div class="vb-edit-section" *ngIf="userVisionboards.length > 0 && !showFinishButton">
    <button class="btn-edit-visionboard" (click)="editVisionBoard()">
      Editar Vision Board
    </button>
  </div>

  <!-- Sección de Tareas Desbloqueadas -->
  <div id="tareas-desbloqueadas" class="vb-unlocked-tasks-section" *ngIf="isVisionBoardComplete && !showTaskSummary">
    <div class="vb-tasks-header">
      <h2 class="vb-tasks-title">Tareas desbloqueadas</h2>
      <p class="vb-tasks-subtitle">
        Despliega y descubre las nuevas tareas desbloqueadas aqui
      </p>
    </div>

    <!-- Card colapsable para las preguntas -->
    <div class="vb-task-card" *ngIf="!showCompletionMessage && !showTaskSummary">
      <div class="vb-task-header" (click)="toggleTaskSection()">
        <h3 class="vb-task-title">1. Responde las siguiente preguntas</h3>
        <svg
          class="vb-task-chevron"
          [class.rotated]="taskSectionExpanded"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M5 7.5L10 12.5L15 7.5"
            stroke="#333"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <!-- Contenido expandible -->
      <div class="vb-task-content" *ngIf="taskSectionExpanded">
        <!-- Mensaje introductorio -->
        <div class="vb-intro-message" *ngIf="showIntroMessage">
          <h2 class="vb-intro-title">Reflexiona sobre tu Vision Board</h2>
          <p class="vb-intro-text">
            Ahora que has terminado de <strong> crear tu Vision Board</strong>, tómate un momento para detenerte y <strong> observarlo con calma.</strong> Este ejercicio te ayudará a 
            <strong> profundizar en lo que has visualizado, a identificar patrones y a reconocer qué aspectos de tu vida resaltan </strong>más en tus metas. Tus respuestas serán una guía
             valiosa para <strong> dar sentido a tus elecciones y comenzar a construir un plan de vida con mayor claridad y propósito.</strong>
          </p>
          <button class="vb-start-btn" (click)="startQuestions()">
            Empezar
          </button>
        </div>

        <!-- Contenedor de preguntas -->
        <div class="vb-question-container" *ngIf="!showIntroMessage">
          <!-- Indicador de progreso -->
          <div class="vb-progress-indicator">
            <span class="vb-progress-text"
              >Preguntas {{ currentQuestion }} de {{ totalQuestions }}</span
            >
            <div class="vb-progress-bar">
              <div
                class="vb-progress-fill"
                [style.width.%]="(currentQuestion / totalQuestions) * 100"
              ></div>
            </div>
          </div>

          <!-- Pregunta actual -->
          <div class="vb-question">
            <div class="vb-question-number">{{ currentQuestion }}</div>
            <div class="vb-question-text">{{ getCurrentQuestion() }}</div>
          </div>

          <!-- Campo de respuesta -->
          <div class="vb-answer-field">
            <input
              type="text"
              class="vb-answer-input"
              [(ngModel)]="currentAnswer"
              placeholder="Ingrese respuesta"
              (keyup.enter)="nextQuestion()"
            />
          </div>

          <!-- Botón continuar -->
          <div class="vb-question-actions">
            <button
              class="vb-continue-btn"
              (click)="nextQuestion()"
              [disabled]="!currentAnswer.trim()"
            >
              Continuar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Sección de finalización -->
    <div class="vb-completion-section" *ngIf="showCompletionMessage && !showTaskSummary">
      <div class="vb-completion-content">
        <h2 class="vb-completion-title">¡Muy bien hecho!</h2>
        <p class="vb-completion-message">
          Has dado un paso importante al reflexionar sobre tu Vision Board. Cada
          respuesta que escribiste es una semilla que te acerca a tu futuro
          ideal. Recuerda que este es solo el comienzo: tu plan de vida se
          construye día a día con intención, claridad y acción.
        </p>
        <button class="vb-finish-btn" (click)="finishTasks()">Finalizar</button>
      </div>
    </div>
  </div>

  <!-- Resumen de las respuestas -->
  <div class="vb-task-summary-container" *ngIf="showTaskSummary">
      <div class="summary-header">
        <h3>Resumen de "Visionboard"</h3>
      </div>

      <!-- Preguntas y respuestas -->
      <div class="vb-questions-summary">
        <div class="vb-questions-items">
          <div
            *ngFor="let question of questions; let i = index"
            class="vb-question-item"
          >
            <div class="question-badge">{{ i + 1 }}</div>
            <div class="question-content">
              <div class="question-label">Pregunta {{ i + 1 }}</div>
              <div class="answer-label">{{ taskAnswers[i] || "Sin respuesta" }}</div>
              <div class="answer-divider"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="summary-actions">
        <button class="btn-edit" (click)="editTaskAnswers()"> 
          <!-- <span class="btn-icon">✏️</span> -->
          Editar respuestas
        </button>
      </div>
  </div>

  <!-- Menú contextual para opciones -->
  <div
    class="vb-options-menu"
    [class.hiding]="isHidingMenu"
    *ngIf="showOptionsMenu"
    [style.top.px]="menuPosition.y"
    [style.left.px]="menuPosition.x"
    (click)="$event.stopPropagation()"
  >
    <div
      class="vb-option-item"
      [class.disabled]="!showFinishButton"
      (click)="showFinishButton ? selectImageOption($event) : null"
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          d="M16.6667 2.5H3.33333C2.8731 2.5 2.5 2.8731 2.5 3.33333V16.6667C2.5 17.1269 2.8731 17.5 3.33333 17.5H16.6667C17.1269 17.5 17.5 17.1269 17.5 16.6667V3.33333C17.5 2.8731 17.1269 2.5 16.6667 2.5Z"
          stroke="#333"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.08333 8.33333C7.77369 8.33333 8.33333 7.77369 8.33333 7.08333C8.33333 6.39298 7.77369 5.83333 7.08333 5.83333C6.39298 5.83333 5.83333 6.39298 5.83333 7.08333C5.83333 7.77369 6.39298 8.33333 7.08333 8.33333Z"
          stroke="#333"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.5 12.5L13.3333 8.33333L3.33333 18.3333"
          stroke="#333"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <span>Subir imagen</span>
    </div>
    <div
      class="vb-option-item"
      [class.disabled]="!showFinishButton"
      (click)="showFinishButton ? selectTextOption() : null"
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          d="M15.8333 3.33333H4.16667C3.70643 3.33333 3.33333 3.70643 3.33333 4.16667V5.83333C3.33333 6.29357 3.70643 6.66667 4.16667 6.66667H15.8333C16.2936 6.66667 16.6667 6.29357 16.6667 5.83333V4.16667C16.6667 3.70643 16.2936 3.33333 15.8333 3.33333Z"
          stroke="#333"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 6.66667V16.6667"
          stroke="#333"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.5 16.6667H12.5"
          stroke="#333"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <span>Agregar texto</span>
    </div>
    <div
      class="vb-option-item vb-option-delete"
      [class.disabled]="!showFinishButton"
      (click)="selectDeleteOption()"
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          d="M2.5 5H4.16667H17.5"
          stroke="#DC2626"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.66667 5V3.33333C6.66667 2.8731 7.03976 2.5 7.5 2.5H12.5C12.9602 2.5 13.3333 2.8731 13.3333 3.33333V5M15.8333 5V16.6667C15.8333 17.1269 15.4602 17.5 15 17.5H5C4.53976 17.5 4.16667 17.1269 4.16667 16.6667V5H15.8333Z"
          stroke="#DC2626"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.33333 9.16667V13.3333"
          stroke="#DC2626"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.6667 9.16667V13.3333"
          stroke="#DC2626"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <span>Eliminar</span>
    </div>
  </div>

  <!-- Modal para texto libre en la pizarra -->
  <div
    class="vb-text-modal"
    *ngIf="showFreeTextModal"
    (click)="closeFreeTextModal()"
  >
    <div class="vb-text-modal-content" (click)="$event.stopPropagation()">
      <h3>Texto libre en la pizarra</h3>

      <!-- Controles de texto -->
      <div class="vb-text-controls">
        <div class="vb-control-group">
          <label>Tamaño de fuente:</label>
          <input
            type="range"
            class="vb-font-size-slider"
            min="12"
            max="72"
            [(ngModel)]="currentFontSize"
            (input)="updateFontSize($event)"
          />
          <span class="vb-font-size-label">{{ currentFontSize }}px</span>
        </div>

        <div class="vb-control-group">
          <label>Color:</label>
          <input
            type="color"
            class="vb-text-color-picker"
            [(ngModel)]="currentTextColor"
            (change)="updateTextColor($event)"
          />
        </div>

        <div class="vb-control-group">
          <label>Estilo:</label>
          <select class="vb-font-family-select" [(ngModel)]="currentFontFamily">
            <option value="Arial">Arial</option>
            <option value="Times New Roman">Times New Roman</option>
            <option value="Courier New">Courier New</option>
            <option value="Georgia">Georgia</option>
            <option value="Verdana">Verdana</option>
            <option value="Comic Sans MS">Comic Sans MS</option>
          </select>
        </div>
      </div>

      <textarea
        [(ngModel)]="currentText"
        placeholder="Escribe tu texto libre aquí..."
        rows="4"
        maxlength="200"
        class="vb-text-input"
      ></textarea>

      <div class="vb-text-modal-actions">
        <button class="btn-cancel" (click)="closeFreeTextModal()">
          Cancelar
        </button>
        <button class="btn-save" (click)="saveFreeText()">
          Agregar a la pizarra
        </button>
      </div>
    </div>
  </div>

  <!-- Modal para agregar texto al elemento del grid -->
  <div
    class="vb-text-modal"
    *ngIf="showGridTextModal"
    (click)="closeGridTextModal()"
  >
    <div class="vb-text-modal-content" (click)="$event.stopPropagation()">
      <h3>Agregar texto al elemento</h3>

      <!-- Área de texto simple para grid -->
      <textarea
        [(ngModel)]="currentText"
        placeholder="Escribe el texto para este elemento..."
        rows="4"
        maxlength="200"
        class="vb-text-input"
      ></textarea>

      <div class="vb-text-modal-actions">
        <button class="btn-cancel" (click)="closeGridTextModal()">
          Cancelar
        </button>
        <button class="btn-save" (click)="saveGridText()">
          Agregar al elemento
        </button>
      </div>
    </div>
  </div>

  <!-- Modal para editar texto existente -->
  <div
    class="vb-text-edit-modal"
    *ngIf="showTextEditModal"
    (click)="closeTextEditModal()"
  >
    <div class="vb-text-modal-content" (click)="$event.stopPropagation()">
      <h3>Editar texto</h3>

      <!-- Controles de texto -->
      <div class="vb-text-controls">
        <div class="vb-control-group">
          <label>Tamaño de fuente:</label>
          <input
            type="range"
            class="vb-font-size-slider"
            min="12"
            max="72"
            [(ngModel)]="editingText.fontSize"
            (input)="updateEditingFontSize($event)"
          />
          <span class="vb-font-size-label">{{ editingText.fontSize }}px</span>
        </div>

        <div class="vb-control-group">
          <label>Color:</label>
          <input
            type="color"
            class="vb-text-color-picker"
            [(ngModel)]="editingText.color"
            (change)="updateEditingTextColor($event)"
          />
        </div>

        <div class="vb-control-group">
          <label>Estilo:</label>
          <select
            class="vb-font-family-select"
            [(ngModel)]="editingText.fontFamily"
          >
            <option value="Arial">Arial</option>
            <option value="Times New Roman">Times New Roman</option>
            <option value="Courier New">Courier New</option>
            <option value="Georgia">Georgia</option>
            <option value="Verdana">Verdana</option>
            <option value="Comic Sans MS">Comic Sans MS</option>
          </select>
        </div>
      </div>

      <textarea
        [(ngModel)]="editingText.text"
        placeholder="Escribe tu texto aquí..."
        rows="4"
        maxlength="200"
        class="vb-text-input"
      ></textarea>

      <div class="vb-text-modal-actions">
        <button class="btn-cancel" (click)="closeTextEditModal()">
          Cancelar
        </button>
        <button class="btn-delete" (click)="deleteText()">Eliminar</button>
        <button class="btn-save" (click)="updateText()">Actualizar</button>
      </div>
    </div>
  </div>

  <!-- Modal de confirmación para eliminar -->
  <div
    class="vb-confirm-modal"
    *ngIf="showConfirmModal"
    (click)="closeConfirmModal()"
  >
    <div class="vb-confirm-modal-content" (click)="$event.stopPropagation()">
      <div class="vb-confirm-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
            stroke="#DC2626"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 8H12.01"
            stroke="#DC2626"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <h3 class="vb-confirm-title">¿Eliminar contenido?</h3>
      <p class="vb-confirm-message">
        ¿Estás seguro de que quieres eliminar el contenido de este elemento?
        Esta acción no se puede deshacer.
      </p>

      <div class="vb-confirm-actions">
        <button class="btn-cancel" (click)="closeConfirmModal()">
          Cancelar
        </button>
        <button class="btn-delete-confirm" (click)="confirmDelete()">
          Eliminar
        </button>
      </div>
    </div>
  </div>

  <!-- Botón para limpiar visionboard -->
  <!-- <div class="vb-clear-section" *ngIf="userVisionboards.length > 0">
    <button class="btn-clear-visionboard" (click)="showClearVisionboardModal()">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          d="M2.5 5H4.16667H17.5"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.66667 5V3.33333C6.66667 2.8731 7.03976 2.5 7.5 2.5H12.5C12.9602 2.5 13.3333 2.8731 13.3333 3.33333V5M15.8333 5V16.6667C15.8333 17.1269 15.4602 17.5 15 17.5H5C4.53976 17.5 4.16667 17.1269 4.16667 16.6667V5H15.8333Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.33333 9.16667V13.3333"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.6667 9.16667V13.3333"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      Limpiar Vision Board
    </button>
  </div> -->

  <!-- Modal de confirmación para limpiar visionboard -->
  <div
    class="vb-confirm-modal"
    *ngIf="showClearConfirmModal"
    (click)="closeClearConfirmModal()"
  >
    <div class="vb-confirm-modal-content" (click)="$event.stopPropagation()">
      <div class="vb-confirm-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
            stroke="#DC2626"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 8H12.01"
            stroke="#DC2626"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <h3 class="vb-confirm-title">¿Limpiar Vision Board?</h3>
      <p class="vb-confirm-message">
        ¿Estás seguro de que quieres limpiar completamente el Vision Board y las tareas guardadas?
        Esta acción eliminará todas las imágenes, textos y respuestas. Esta acción no se puede deshacer.
      </p>

      <div class="vb-confirm-actions">
        <button class="btn-cancel" (click)="closeClearConfirmModal()">
          Cancelar
        </button>
        <button class="btn-delete-confirm" (click)="clearVisionboard()">
          Limpiar Todo
        </button>
      </div>
    </div>
  </div>
</div>
